'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = require('../constants');

var _compute = require('../compute');

var _symbols = require('./symbols');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var symbolByShape = {
    circle: _symbols.SymbolCircle,
    diamond: _symbols.SymbolDiamond,
    square: _symbols.SymbolSquare,
    triangle: _symbols.SymbolTriangle
};

var LegendSvgItem = function (_Component) {
    _inherits(LegendSvgItem, _Component);

    function LegendSvgItem() {
        _classCallCheck(this, LegendSvgItem);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    LegendSvgItem.prototype.render = function render() {
        var _props = this.props,
            x = _props.x,
            y = _props.y,
            width = _props.width,
            height = _props.height,
            symbolSize = _props.symbolSize,
            symbolSpacing = _props.symbolSpacing,
            symbolShape = _props.symbolShape,
            label = _props.label,
            fill = _props.fill,
            direction = _props.direction,
            justify = _props.justify;

        var _computeItemLayout = (0, _compute.computeItemLayout)({
            direction: direction,
            justify: justify,
            symbolSize: symbolSize,
            symbolSpacing: symbolSpacing,
            width: width,
            height: height
        }),
            symbolX = _computeItemLayout.symbolX,
            symbolY = _computeItemLayout.symbolY,
            labelX = _computeItemLayout.labelX,
            labelY = _computeItemLayout.labelY,
            labelAnchor = _computeItemLayout.labelAnchor,
            labelAlignment = _computeItemLayout.labelAlignment;

        var Symbol = symbolByShape[symbolShape];

        return _react2.default.createElement(
            'g',
            { transform: 'translate(' + x + ',' + y + ')' },
            _react2.default.createElement(Symbol, { x: symbolX, y: symbolY, size: symbolSize, fill: fill }),
            _react2.default.createElement(
                'text',
                {
                    textAnchor: labelAnchor,
                    style: { fill: 'black', alignmentBaseline: labelAlignment },
                    x: labelX,
                    y: labelY
                },
                label
            )
        );
    };

    return LegendSvgItem;
}(_react.Component);

LegendSvgItem.propTypes = {
    x: _propTypes2.default.number.isRequired,
    y: _propTypes2.default.number.isRequired,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,

    symbolSize: _propTypes2.default.number.isRequired,
    symbolSpacing: _propTypes2.default.number.isRequired,
    symbolShape: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(Object.keys(symbolByShape)), _propTypes2.default.func]).isRequired,

    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    fill: _propTypes2.default.string.isRequired,

    direction: _propTypes2.default.oneOf([_constants.DIRECTION_LEFT_TO_RIGHT, _constants.DIRECTION_RIGHT_TO_LEFT, _constants.DIRECTION_TOP_TO_BOTTOM, _constants.DIRECTION_BOTTOM_TO_TOP]).isRequired,
    justify: _propTypes2.default.bool.isRequired
};
LegendSvgItem.defaultProps = {
    direction: _constants.DIRECTION_LEFT_TO_RIGHT,
    justify: false,
    symbolSize: 16,
    symbolSpacing: 8,
    symbolShape: 'square'
};
exports.default = LegendSvgItem;


//////////////////
// WEBPACK FOOTER
// ./~/@nivo/legends/lib/svg/LegendSvgItem.js
// module id = 128
// module chunks = 168707334958949